import styled from 'styled-components';

export const ModalCarouselWrapper = styled.div`
    .modal-collapse-scrollable .ant-collapse {
        background-color: var(--app-surface-alt);
        border-radius: 2px;
        border: none;
    }

    .modal-collapse-scrollable .ant-collapse-content {
        background-color: var(--app-surface);
        padding: 12px 20px;
        border-top: 1px solid var(--app-border);
    }

    /* Collapse active header styles */
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header {
        background-color: color-mix(in srgb, #1677ff 12%, var(--app-surface));
    }

    [data-bs-theme="dark"] & .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header {
        background-color: transparent;
    }
    
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .text-gray-800,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .fw-bold,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .text-hover-danger,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .gotham_black,
    .modal-collapse-scrollable .ant-collapse-item-active .ant-collapse-header .fs-6 {
        color: #1677ff !important;
    }
`;